export const nav = {
  dashboard: 'Dashboard',
  customers: 'Customers',
  customerGroups: 'Customer Groups',
  documentStorage: 'Library',
  documentLibrary: 'Library',
  suppliers: 'Suppliers',
  notes: 'Sticky Notes',
  richNotes: 'Notebook',
  appointments: 'Appointments',
  customerPortal: 'Customer Portal',
  missingItems: 'Missing Items',
  customerRelationshipLogs: 'Relationship Logs',
  products: 'Products',
  categories: 'Categories',
  warehouse: 'Warehouses',
  inventory: 'Inventory',
  warranty: 'Warranty',
  offers: 'Quotations',
  ai_quotations: 'AI Quotations',
  contracts: 'Documents',
  templates: 'Templates',
  documentVariables: 'Variables',
  formBuilder: 'Forms & Lists',
  formBuilderEditor: 'Form Builder',
  flowBuilder: 'Flow Builder',
  myForms: 'My Forms',
  worksheets: 'Worksheets',
  deals: 'Deals',
  reports: 'Reports',
  vehicles: 'Vehicles',
  bookings: 'Bookings',
  customerVehicles: 'Customer Vehicles',
  vehicleSettings: 'Vehicle Settings',
  maintenance: 'Maintenance & Service',
  fuel: 'Fuel Management',
  documents: 'Documents',
  expenses: 'Expenses',
  fleetReports: 'Reports & Analytics',
  settings: 'Settings',
  profile: 'Profile',
  system_admin: 'System admin',
  storageOptimization: 'Storage Optimization',
  workPagesTemplates: 'Workpage templates',
  filledWorkpage: 'Filled workpage',
  billing: 'Billing',
  billingSubtitle: 'Invoices, proformas and credit notes management',
  tasks: 'Tasks',
  tasksSubtitle: 'Task and to-do management',
  projects: 'Projects',
  projectsSubtitle: 'Project management and tracking',
  projectBoard: 'Project Board',
  pipeline: 'Pipeline',
  quotations: 'Quotations',
  orders: 'Orders',
  delivery_notes: 'Delivery Notes',
  sales: 'Sales',
  organization: 'Organization',
  selectOrganization: 'Select Organization',
  groups: {
    crm: 'CRM & Contacts',
    products: 'Products & Inventory',
    sales: 'Sales & Orders',
    documents: 'Documents',
    contracts: 'Contracts',
    forms: 'Forms',
    processes: 'Processes',
    projects: 'Projects & Tasks',
    finance: 'Finance',
    fleet: 'Fleet Management'
  },
  expandSidebar: 'Expand Sidebar',
  collapseSidebar: 'Collapse Sidebar'
}